/**
 * Shared PostHog client configuration checks (must stay in sync with main.tsx bootstrap).
 */
export function isPostHogConfigured(): boolean {
  const posthogApiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
  return Boolean(
    posthogApiKey &&
      typeof posthogApiKey === 'string' &&
      posthogApiKey.trim().length > 0
  );
}
